import { render, staticRenderFns } from "./QueTable.vue?vue&type=template&id=ca11d674&scoped=true"
import script from "./QueTable.vue?vue&type=script&lang=js"
export * from "./QueTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca11d674",
  null
  
)

export default component.exports